/**
 * Funcion que en base a las medidas del document interpreta la orientacion donde
 * puede entrar un elemento flotante.
 * @param {Object} hoverRect - Dimensiones del elemento en base al cual se acomoda: elementRect
 * @param {Object} elementRect - Dimensiones del elemento a posicionar
 * @returns {string} Retorna uno de los siguientes valores:["right","left","top","bottom"]
 */
export const getPositionSuggestion = (hoverRect, elementRect) => {
  const docWidth = document.documentElement.clientWidth;
  const docHeight = document.documentElement.clientHeight;
  // ubicacion exacta en el doc. del elemento en el que se hace click/hover
  const realHoverRightX = hoverRect.x + hoverRect.width;
  const realHoverLeftX = hoverRect.x;
  const realHoverTopY = hoverRect.y;
  const realHoverBottomY = hoverRect.y + hoverRect.height;

  // por donde el componente se mantiene dentro de la vista
  const byRight = realHoverRightX + elementRect.width / 2 <= window.scrollX + docWidth;
  const byLeft = realHoverLeftX - elementRect.width / 2 >= 0;
  const byAbove = realHoverTopY - elementRect.height >= 0;
  const byBellow = realHoverBottomY + elementRect.height <= window.scrollY + docHeight;

  if (!byRight && byLeft) return 'left';
  if (!byLeft && byRight) return 'right';
  if (!byAbove && byBellow) return 'bottom';
  return 'top';
};
